import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { Navigate } from '@ngxs/router-plugin';
import { State, Action, StateContext } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';

import { OfficeSecurityService, CoreFacade } from '@core/core.module';

import { MenuItem } from '../models/menu-item.model';
import * as actions from './navigation.actions';

export interface NavigationStateModel {
    menu: MenuItem[];
    userMenu: MenuItem[];
}

@Injectable({
    providedIn: 'root'
})
@State<NavigationStateModel>({
    name: 'navigation',
    defaults: {
        menu: null,
        userMenu: null
    }
})
export class NavigationState {
    constructor(
        private translateService: TranslateService,
        private privilegesService: OfficeSecurityService,
        private coreFacade: CoreFacade,
        private location: Location
    ) {}

    @Action(actions.LoadAuthenticatedMenuAction)
    loadAuthenticatedMenuAction(ctx: StateContext<NavigationStateModel>) {
        const menu = this.getMenu();
        const userMenu = [
            {
                code: 'logOut',
                displayText: this.translateService.instant('Navbar.LogOut'),
                isVisible: true,
                routerLink: ''
            }
        ] as MenuItem[];
        ctx.patchState({ menu, userMenu });
    }

    @Action(actions.ClearMenuAction)
    clearMenuAction(ctx: StateContext<NavigationStateModel>) {
        ctx.patchState({ menu: null, userMenu: null });
    }

    @Action(actions.NavigateAction)
    navigate(ctx: StateContext<NavigationStateModel>, action: actions.NavigateAction) {
        const selectedClub = this.coreFacade.selectedClub();

        const url = action.isClubContext ? `${selectedClub.id}/${action.url}` : action.url;
        ctx.dispatch(new Navigate([url], action.queryParams));
    }

    @Action(actions.RefreshMenuAction)
    refreshMenu(ctx: StateContext<NavigationStateModel>) {
        const menu = this.getMenu();
        ctx.patchState({ menu });
    }

    @Action(actions.GoBack)
    goBack(ctx: StateContext<NavigationStateModel>) {
        this.location.back();
    }

    private getMenu(): MenuItem[] {
        const menu = [];

        menu.push({
            displayText: this.translateService.instant('Navbar.CourtSheetLabel'),
            isVisible: true,
            routerLink: '/court-sheet',
            isClubContext: true
        } as MenuItem);

        menu.push({
            displayText: this.translateService.instant('Navbar.EventListLabel'),
            isVisible: true,
            routerLink: '/court-events',
            isClubContext: true
        } as MenuItem);

        if (this.privilegesService.canManageCourtsSnapshot) {
            menu.push({
                displayText: this.translateService.instant('Navbar.CourtManagementLabel'),
                isVisible: true,
                routerLink: '/court-management',
                isClubContext: true
            } as MenuItem);
        }

        if (this.privilegesService.canViewRulesMatrixSnapshot) {
            menu.push({
                displayText: this.translateService.instant('Navbar.RulesLabel'),
                isVisible: true,
                routerLink: '/rules-matrix',
                isClubContext: false
            } as MenuItem);
        }

        // if (this.privilegesService.canViewReports) {
        //     menu.push({
        //         displayText: this.translateService.instant('Navbar.Reports'),
        //         isVisible: true,
        //         routerLink: '/reports',
        //         isClubContext: false
        //     } as MenuItem);
        // }

        return menu;
    }
}
